<script setup>
import { ExclamationIcon } from "@heroicons/vue/solid";
import { LogoutIcon } from '@heroicons/vue/outline'
import HandlesAuthorization from "@/Mixins/HandlesAuthorization.js"
const { logout } = HandlesAuthorization()
</script>

<template>

	<div class="shadow sm:rounded-md sm:overflow-hidden bg-white sm:px-6 px-4 py-10 w-fit text-center mx-auto">
		<div class="flex justify-center mb-4"><ExclamationIcon  class="text-Yellow w-14"/></div>
		<p>There are no active memberships associated with this user account.</p>
		<p class="mt-2">This may be due to a pending review of your membership application or because your membership has expired.</p>
		<p class="mt-2">If you think this might be a mistake or you'd like to renew your membership, <a href="mailto:admin@advancecairns.com">click here</a> to get in touch.</p>
		
		<button @click="logout()" class="flex row mt-16 float-right">
			<LogoutIcon
				class="text-gray-400 group-hover:text-gray-500 flex-shrink-0 -ml-1 mr-3 h-6 w-6" 
			/>
			Log out
		</button>
	</div>

</template>